const DEFAULT_RETURN_TO = "/dashboard";
const NESTED_RETURN_ROOTS = ["/dashboard", "/products", "/context-meshes"];
const EXACT_RETURN_PATHS = new Set(["/files", "/integrations"]);

function isAllowedReturnPath(pathname: string): boolean {
    return EXACT_RETURN_PATHS.has(pathname)
        || NESTED_RETURN_ROOTS.some(root => pathname === root || pathname.startsWith(`${root}/`));
}

export function safeReturnTo(value: string | null | undefined): string {
    if (!value || !value.startsWith("/") || value.startsWith("//")) return DEFAULT_RETURN_TO;
    try {
        const parsed = new URL(value, "https://product-studio.invalid");
        if (parsed.origin !== "https://product-studio.invalid") return DEFAULT_RETURN_TO;
        if (!isAllowedReturnPath(parsed.pathname)) return DEFAULT_RETURN_TO;
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
        return DEFAULT_RETURN_TO;
    }
}

export function returnToFromSearch(search: string): string {
    return safeReturnTo(new URLSearchParams(search).get("returnTo"));
}

export function authPath(returnTo: string): string {
    const safe = safeReturnTo(returnTo);
    return safe === DEFAULT_RETURN_TO ? "/auth" : `/auth?returnTo=${encodeURIComponent(safe)}`;
}

export function splashPath(returnTo: string): string {
    const safe = safeReturnTo(returnTo);
    return safe === DEFAULT_RETURN_TO ? "/splash" : `/splash?returnTo=${encodeURIComponent(safe)}`;
}
